export default __webpack_public_path__ + "static/media/avatar_nikki_dog5.ecbe3ca8.mp3";